import {Box, Button, Typography} from '@viptech/react-components'
import {useSnackbar} from 'notistack'
import {useEffect, useState} from 'react'
import {VerifyUserAndCompanyPermission} from 'src/common/utils/ValidatePermissions'
import {useCameraConfigContext} from '../../../../../../context/CameraConfigContext'
import {StepperModalActionsButtonContainer} from '../../../styles'
import {ChosenObject} from '../../StepperModal'
import Card from '../../common/components/Card'
import {detections, detectionsNotAllowedOnVmsCameras} from '../Constants'
import {BoxOnContainerDetectionType, ContainerColumn} from './DetectionTypeBase'

type DetectionTypeStepProps = {
  nextFunction: (index: number, resume: string, advanceTo?: number) => void
  returnFunction: (isOpen: boolean) => void
  setChosen: (choices: Partial<ChosenObject>) => void
  selected?: string | null
}

const DetectionTypeStep = (props: DetectionTypeStepProps) => {
  const {nextFunction, returnFunction, setChosen, selected} = props
  const {camera} = useCameraConfigContext()

  const hasFacialListPermission = VerifyUserAndCompanyPermission([camera?.companyId!], 'face:create')
  const hasLprListPermission = VerifyUserAndCompanyPermission([camera?.companyId!], 'lpr:create')
  const hasCountingPermission = VerifyUserAndCompanyPermission([camera?.companyId!], 'detector-counter:read')
  const hasObjectRemovalPermission = VerifyUserAndCompanyPermission([camera?.companyId!], 'object-removal:create')
  const hasSpeedPermission = VerifyUserAndCompanyPermission([camera?.companyId!], 'speed:create')
  const hasTrackingDetectionsPermission = VerifyUserAndCompanyPermission([camera?.companyId!], 'tracking:create')

  const {enqueueSnackbar} = useSnackbar()

  const [selectedCard, setSelectedCard] = useState(selected || '')

  const enumCardLabelsToValidatePermission = [
    'Reconhecimento Facial',
    'Leitura de Placas',
    'Relatório de Contagem',
    'Remoção de Objeto',
    'Velocidade',
    'Tempo de Permanência',
    'Análise Demográfica',
  ]
  const enumCardPermissions = [
    hasFacialListPermission,
    hasLprListPermission,
    hasCountingPermission,
    hasObjectRemovalPermission,
    hasSpeedPermission,
    hasTrackingDetectionsPermission,
    hasTrackingDetectionsPermission && hasFacialListPermission,
  ]

  const handleConfidenceValue = () => {
    if (selectedCard === 'Reconhecimento Facial') return 0.3
    if (selectedCard === 'Análise Demográfica') return 0.3
    if (selectedCard === 'Leitura de Placas') return 0.5
    return 0.4
  }

  useEffect(() => {
    setChosen({
      detectionTypeChosen: selectedCard,
      isObjectCounting: selectedCard === 'Relatório de Contagem' ? true : undefined,
      isObjectPermanency: selectedCard === 'Tempo de Permanência' ? true : undefined,
      confidence: handleConfidenceValue(),
    })
  }, [selectedCard])

  const handleSelectCard = (cardSelected: string) => {
    const indexOfSelectedCard = enumCardLabelsToValidatePermission.indexOf(cardSelected)
    if (camera?.origin === 'Digifort' && detectionsNotAllowedOnVmsCameras.includes(cardSelected)) {
      enqueueSnackbar(
        <Box display='flex' direction='column'>
          <p>A configuração da sua câmera não é compatível com a detecção escolhida.</p>
          <p>Entre em contato com o suporte para mais informações.</p>
        </Box>,
        {variant: 'warning'},
      )
      return
    }
    if (indexOfSelectedCard === -1) return setSelectedCard(cardSelected)
    if (enumCardPermissions[indexOfSelectedCard]) return setSelectedCard(cardSelected)

    enqueueSnackbar(
      <Box display='flex' direction='column'>
        <div>Você não tem as permissões necessárias para criar este tipo de detecção</div>
        <div>Entre em contato com o administrador para obter as permissões apropriadas</div>
      </Box>,
      {variant: 'warning'},
    )
  }

  return (
    <BoxOnContainerDetectionType>
      <Box paddingTop='20px'>
        <Typography variant='span' size='16px' style={{fontWeight: 500}}>
          O que você deseja detectar?
        </Typography>
        <Typography variant='p' size='12px' color='#8E8E8E'>
          Escolha abaixo o tipo de detecção que melhor atenda às suas necessidades de monitoramento e segurança.
        </Typography>

        <ContainerColumn>
          {detections.map((it) => {
            return <Card dispatchTo={it} selected={selectedCard === it} onClick={() => handleSelectCard(it)} initialState={!selectedCard} />
          })}
        </ContainerColumn>
      </Box>
      <StepperModalActionsButtonContainer>
        <Button fontSize='12px' height='40px' width='150px' variant='outlined' color='#8E8E8E' onClick={() => returnFunction(false)}>
          Cancelar
        </Button>
        <Button fontSize='12px' height='40px' width='150px' disabledTextColor='#8E8E8E' disabled={!selectedCard} onClick={() => nextFunction(1, selectedCard)}>
          Próximo
        </Button>
      </StepperModalActionsButtonContainer>
    </BoxOnContainerDetectionType>
  )
}

export default DetectionTypeStep
